<template>
  <div class="tags">
    <div class="tags__results-counter" v-show="tags.length > 0 && productsAmount > 0">
      {{ $tc('items', productsAmount, { count: productsAmount }) }}
    </div>
    <div class="tags__container">
      <Tag v-for="(tag, i) in tags" :key="tag.value + i" :tag="tag" />
      <div v-show="tags.length" class="tags__clear-filters" @click="clearSecondaryFilters">
        {{ $t('clear') }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import Tag from './Tag/Tag.vue'

export default {
  name: 'Tags',

  components: { Tag },

  computed: {
    ...mapState('filter', ['pageInfo']),

    ...mapGetters('filter', ['activeSecondaryFilters']),

    tags() {
      return this.activeSecondaryFilters.reduce((tags, filter) => {
        const tag = filter.values.map(value => ({
          id: filter.id,
          label: filter.options.find(option => option.value === value).label,
          value: value,
          order: filter.order,
        }))
        return [...tags, ...tag]
      }, [])
    },

    productsAmount() {
      return this.pageInfo.totalCount
    },
  },

  methods: {
    ...mapActions({
      clearSecondaryFilters: 'filter/clearSecondaryFilters',
    }),
  },
}
</script>

<style lang="scss" scoped>
.tags {
  display: flex;
  flex: 1;
  align-items: center;

  @media ($mq-large) {
    margin: 8px 0 8px 20px;
  }

  &__results-counter {
    align-self: flex-start;
    margin-right: 25px;
    padding: 27px 0 20px;
    cursor: default;
    line-height: 0;
    white-space: nowrap;
    color: $color-grey-mid-2;

    @media ($mq-high) {
      display: block;
    }
  }

  &__container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    @media ($mq-large) {
      margin-right: 25px;
    }
  }

  &__clear-filters {
    margin: 5px 10px 5px 0;
    padding: 4px 0 4px 15px;
    border-radius: 2px;
    cursor: pointer;
    user-select: none;
    font-size: $font-size-small;
    white-space: nowrap;
    letter-spacing: $font-spacing-medium;
    color: $color-grey-dark-2;

    @media ($mq-large) {
      margin: 5px 13px 5px 0;
      padding: 12px 0 11px 0;
      font-size: $font-size-normal;
    }
  }
}
</style>

<i18n src="@/locales/filter_tags.json">
</i18n>
